import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Avatar, Flex, Image, Stack, Text } from "@mantine/core";
import { IconChevronRight, IconError404, IconUser } from "@tabler/icons-react";

import { CampaignBadge } from "../../../CampaignBadge";

export interface CampaignItemProps {
    id: string;
    name: string;
    image?: string;
    dateFrom: string;
    dateTo: string;
    candidates: number;
}

export const CampaignItem = ({ id, dateTo, dateFrom, name, image, candidates }: CampaignItemProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation(["common"]);
    const handleRedirect = () => {
        navigate(`/campaign/${id}`);
    };
    return (
        <Flex gap={16} style={{ cursor: "pointer" }} onClick={handleRedirect}>
            {image ? (
                <Image radius={8} height={72} width={72} src={image} />
            ) : (
                <Avatar radius={8} size={72}>
                    <IconError404 />
                </Avatar>
            )}
            <Stack spacing={4}>
                <Text size={14} weight={600} style={{ lineHeight: 1.2 }}>
                    {name}
                </Text>
                <Text color="#888E98" size={14} style={{ lineHeight: 1.2 }}>
                    {dateFrom} - {dateTo}
                </Text>
                <Flex wrap="wrap" gap={8}>
                    <CampaignBadge
                        color="rgba(48,169,212,0.12)"
                        textColor="#30A9D4"
                        icon={<IconUser fill="#30A9D4" size={14} />}
                    >
                        {t("dashboard_in_progress_candidates", { count: candidates })}
                    </CampaignBadge>
                </Flex>
            </Stack>
            <Flex align="center" ml="auto">
                <IconChevronRight size={20} />
            </Flex>
        </Flex>
    );
};
